import { client } from '../client';
import { ProviderProfile, UserProfile } from './types/UserProfile';

export const saveProviderProfile = async (payload: ProviderProfile, user_id: number): Promise<UserProfile> => {
  const { data } = await client.patch<UserProfile>(`/users/${user_id}/provider_profile`, payload);

  return data;
};
